import React, { useMemo } from 'react'
import ClassFinderDataLoader from './ClassFinderDataLoader'
import ReduxContainer from '../../reduxContainer/ReduxContainer'
import UserLoadWrapper from '../../reduxContainer/UserLoadWrapper'
import camelize from 'camelize'
import './classFinder.scss'
import {
  difficultyFilterOptions,
  intensityFilterOptions
} from './classFinderDropdownInfo'
import { LightTheme } from 'ui/bend'
import { ThemeProvider } from 'styled-components'

const generateFilteredParams = (filtered) =>
  filtered && typeof filtered === 'string' ? filtered.split(',') : []

const ClassFinder = (props) => {
  const metaInfo = useMemo(() => {
    const instructorFilterOptions = camelize(props.instructorFilterOptions)
    const categoryFilterOptions = camelize(props.categoryFilterOptions)

    const preloadedFilters = {
      instructors: generateFilteredParams(props.filteredInstructors),
      styles: generateFilteredParams(props.filteredStyles),
      difficulties: generateFilteredParams(props.filteredDifficulties),
      intensities: generateFilteredParams(props.filteredIntensities).map((i) =>
        parseInt(i, 10)
      ),
      equipment: generateFilteredParams(props.filteredEquipment),
      focus_area: generateFilteredParams(props.filteredFocusArea),
      excludeCompleted: props.excludeCompleted,
      duration: generateFilteredParams(props.duration)
    }

    return {
      defaultValue: props.defaultValue,
      autopaginate: props.autopaginate,
      includeFilters: props.includeFilters,
      defaultOrder: props.defaultOrder,
      preloadedFilters,
      baseUrl: props.baseUrl,
      withSubcategories: props.withSubcategories,
      dropdownOptions: {
        duration: [],
        instructors: instructorFilterOptions,
        styles: categoryFilterOptions,
        intensities: intensityFilterOptions,
        difficulties: difficultyFilterOptions,
        focus_area: props.focusAreaTags,
        equipment: props.equipmentTags
      }
    }
  }, [props])

  return metaInfo ? (
    <ReduxContainer>
      <UserLoadWrapper>
        <ThemeProvider theme={LightTheme}>
          <div className='ClassFinder'>
            <ClassFinderDataLoader {...metaInfo} />
          </div>
        </ThemeProvider>
      </UserLoadWrapper>
    </ReduxContainer>
  ) : null
}

export default ClassFinder
